var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnalyse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bold_chart",
    "data-name": "vuesax/bold/chart",
    transform: "translate(-556 -252)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "chart",
    transform: "translate(556 252)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.833,1H.5A.5.5,0,0,1,0,.5.5.5,0,0,1,.5,0H13.833a.5.5,0,0,1,.5.5A.5.5,0,0,1,13.833,1Z",
    transform: "translate(0.833 13.667)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M0,1.333v12H3v-12C3,.6,2.7,0,1.8,0H1.2C.3,0,0,.6,0,1.333Z",
    transform: "translate(6.5 1.333)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,1.333v8H2.667v-8C2.667.6,2.4,0,1.6,0H1.067C.267,0,0,.6,0,1.333Z",
    transform: "translate(2 5.333)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M0,1.333V6H2.667V1.333C2.667.6,2.4,0,1.6,0H1.067C.267,0,0,.6,0,1.333Z",
    transform: "translate(11.333 8.667)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M0,0H16V16H0Z",
    transform: "translate(16 16) rotate(180)",
    fill: "none",
    opacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyse);
export default __webpack_public_path__ + "static/media/analyse.dc8c6843e4c1af9ff3080241dd1f36ae.svg";
export { ForwardRef as ReactComponent };